import _ from "lodash";
import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Prop } from "vue-property-decorator";

@Component({})
export default class CheckOrDropdown extends Vue {
  @Prop(Array)
  data!: Array<any>;

  @Prop(Boolean)
  disabled!: boolean;

  editableList: any[] = [];

  mounted() {
    // Make a copy so it doesn't get overwritten by next update
    this.editableList = _.cloneDeep(this.data);
    this.riskUpdate();
  }

  @Emit()
  riskUpdate() {
    return this.editableList.map(item => {
      const other = item.id.startsWith("Other");
      return { key: item.id, value: item.value, other, text: item.text };
    });
  }

  textInput(item: any) {
    item.value = item.text ? 1 : 0;
    this.riskUpdate();
    this.checkIfAdd();
  }

  checkIfAdd() {
    const last = this.editableList[this.editableList.length - 1];
    if (last.text && last.value) {
      const oldIdParts = last.id.split(".");
      oldIdParts[2]++;
      const newId = oldIdParts.join(".");
      const { category, format, index } = last;
      const newItem = {
        id: newId,
        text: "",
        value: 0,
        category,
        format,
        index
      };
      this.editableList.push(newItem);
    }
  }
}
